export function requireLogin(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("login") === "true";
}
